<template>
    <div class="flex h-screen">
        <Sidebar />

        <div class="flex-1 flex flex-col overflow-hidden">
            <header class="lg:hidden flex items-center gap-3 px-3 py-2.5 bg-sidebar text-primary shrink-0">
                <UButton icon="i-lucide-menu" variant="ghost" color="neutral" size="md"
                    class="text-primary hover:bg-white/10" @click="appStore.toggleSidebar()" />
                <img src="/branding/meltal-icon.png" alt="Meltal Group" class="size-7 shrink-0 rounded-[7px]" />
                <span class="font-display font-semibold text-sidebar-strong">{{ $t('app.name') }}</span>
            </header>

            <main class="flex-1 overflow-auto px-4 py-5 lg:px-9 lg:py-6">
                <div class="hidden lg:flex items-center justify-end gap-2 pb-3 mb-5 border-b border-default font-display text-[11px] font-medium uppercase tracking-[.08em] text-muted">
                    <img src="/branding/meltal-icon.png" alt="" class="size-[18px] rounded-[5px]" />
                    <span>{{ $t('app.company') }}</span>
                </div>

                <router-view />
            </main>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { watch } from 'vue'
    import { useRoute } from 'vue-router'

    import Sidebar from '@/layouts/components/Sidebar.vue'
    import { useAppStore } from '@/stores/app'

    const appStore = useAppStore()
    const route = useRoute()

    // Close the mobile drawer whenever the user navigates — on desktop this is a
    // harmless no-op since the sidebar's visibility there is CSS-driven, not tied
    // to sidebarOpen.
    watch(() => route.fullPath, () => appStore.closeSidebar())
</script>
